import React from "react";
import { Box } from "@mui/material";
import { SxProps, Theme } from "@mui/system";
import AtticusLogo from "../assets/atticus-logo.svg";
import TSGPartnership from "../assets/advisor-groups/trustee-services-group/tsg-partnership.svg";
import TSGPartnershipAlt from "../assets/advisor-groups/trustee-services-group/tsg-partnership-dark-background.svg";
import TSGPartnershipSecondary from "../assets/advisor-groups/trustee-services-group/tsg-partnership-secondary.svg";
import TSGPartnershipSecondaryAlt from "../assets/advisor-groups/trustee-services-group/tsg-partnership-secondary-dark-background.svg";

const partnershipLogoPool: { [key: string]: any } = {
  "AG-TrusteeServicesGroup": {
    partnership: TSGPartnership,
    partnershipAlt: TSGPartnershipAlt,
    partnershipSecondary: TSGPartnershipSecondary,
    partnershipSecondaryAlt: TSGPartnershipSecondaryAlt,
  },
};

export interface Props {
  title?: string;
  advisorGroupKey?: string;
  secondary?: boolean;
  darkBg?: boolean;
  sx?: SxProps<Theme>;
}

export const BrandLogo = ({
  title,
  advisorGroupKey,
  secondary = false,
  darkBg = false,
  sx,
}: Props): JSX.Element => {
  const logoGroup = advisorGroupKey
    ? partnershipLogoPool[advisorGroupKey]
    : undefined;
  let imageSource = AtticusLogo;

  if (logoGroup) {
    if (secondary) {
      imageSource = darkBg
        ? logoGroup.partnershipSecondaryAlt
        : logoGroup.partnershipSecondary;
    } else {
      imageSource = darkBg ? logoGroup.partnershipAlt : logoGroup.partnership;
    }
  }

  const imageTitle = title
    ? title
    : advisorGroupKey
    ? "Atticus + " + advisorGroupKey
    : "Atticus Estate Settlement";

  return (
    <Box
      component="img"
      src={imageSource}
      alt={imageTitle}
      title={imageTitle}
      sx={sx}
    />
  );
};
